import { put, takeLatest } from "redux-saga/effects";
import {
  requestMemberSubscriptionInvoiceList,
  requestMemberSubscriptionInvoiceCreate,
  requestForSubscriptionChangeStatus,
  requestMemberList,
  requestSubscriptionPackageList,
  requestGetByIdMemberSubscriptionInvoiceList
} from "services/acclgl/invoice/memberSubscriptionInvoiceList";
import {
  fetchMemberSubscriptionInvoiceListRequest,
  fetchMemberSubscriptionInvoiceListSuccess,
  fetchMemberSubscriptionInvoiceListFailure,
  createMemberSubscriptionInvoiceRequest,
  createMemberSubscriptionInvoiceSuccess,
  createMemberSubscriptionInvoiceFailure,
  memberSubscriptionChangeStatusRequest,
  memberSubscriptionChangeStatusSuccess,
  memberSubscriptionChangeStatusFailure,
  fetchMemberListRequest,
  fetchMemberListSuccess,
  fetchMemberListFailure,
  fetchSubscriptionPackageListRequest,
  fetchSubscriptionPackageListSuccess,
  fetchSubscriptionPackageListFailure,
  fetchMemberSubscriptionInvoiceByIdRequest,
  fetchMemberSubscriptionInvoiceByIdSuccess,
  fetchMemberSubscriptionInvoiceByIdFailure,
} from "redux/reducers/acclgl/invoice/memberSubscriptionInvoiceList";
export function* watchMemberSubscriptionInvoiceListSaga() {
  yield takeLatest(
    fetchMemberSubscriptionInvoiceListRequest,
    fetchMemberSubscriptionInvoiceList
  );
  yield takeLatest(
    createMemberSubscriptionInvoiceRequest,
    createMemberSubscriptionInvoice
  );
  yield takeLatest(
    memberSubscriptionChangeStatusRequest,
    memberSubscriptionChangeStatus
  );
  yield takeLatest(
    fetchMemberListRequest,
    fetchMemberList
  );
  yield takeLatest(
    fetchSubscriptionPackageListRequest,
    fetchSubscriptionPackageList
  );

  yield takeLatest(
    fetchMemberSubscriptionInvoiceByIdRequest,
    fetchMemberSubscriptionInvoiceById
  );
}

function* fetchMemberSubscriptionInvoiceList({ payload }) {
  try {
    const response = yield requestMemberSubscriptionInvoiceList(payload);
    yield put(fetchMemberSubscriptionInvoiceListSuccess(response));
  } catch (error) {
    yield put(
      fetchMemberSubscriptionInvoiceListFailure(
        "Failed to get list of Member Subscription"
      )
    );
  }
}

function* createMemberSubscriptionInvoice({ payload }) {
  try {
    const response = yield requestMemberSubscriptionInvoiceCreate(payload);
    yield put(createMemberSubscriptionInvoiceSuccess(response.data));
  } catch (error) {
    yield put(createMemberSubscriptionInvoiceFailure("Failed to create"));
  }
}

function* memberSubscriptionChangeStatus({ payload }) {
  try {
    const response = yield requestForSubscriptionChangeStatus(payload);
    yield put(memberSubscriptionChangeStatusSuccess(response.data));
  } catch (error) {
    yield put(memberSubscriptionChangeStatusFailure("Failed to get Data"));
  }
}

function* fetchMemberList({ payload }) {
  try {
    const response = yield requestMemberList(payload);
    yield put(fetchMemberListSuccess(response));
  } catch (error) {
    yield put(
      fetchMemberListFailure(
        "Failed to get list of Member"
      )
    );
  }
}

function* fetchSubscriptionPackageList({ payload }) {
  try {
    const response = yield requestSubscriptionPackageList(payload);
    yield put(fetchSubscriptionPackageListSuccess(response));
  } catch (error) {
    yield put(
      fetchSubscriptionPackageListFailure(
        "Failed to get list of Subscription Package"
      )
    );
  }
}

function* fetchMemberSubscriptionInvoiceById({ payload }) {
  try {
    const response = yield requestGetByIdMemberSubscriptionInvoiceList(payload);
    yield put(fetchMemberSubscriptionInvoiceByIdSuccess(response));
  } catch (error) {
    yield put(fetchMemberSubscriptionInvoiceByIdFailure("Failed to get Member Subscription Invoice Data By Id"));
  }
}